// src/stage2/sceneInterior/ClassroomScene.jsx
import React, { useMemo } from 'react';
import { useGLTF } from '@react-three/drei';
import Book from './Book';

export function ClassroomScene() {
  // IMPORTANT: load from /public via absolute path
  const { scene } = useGLTF('/stageAssets/stage2/interior/classroom.gltf');

  // optional: if your classroom is huge or rotated wrong, adjust here
  const props = useMemo(() => ({
    position: [0, 0, 0],
    rotation: [0, 0, 0],
    scale: 1
  }), []);

  return (
    <group>
      <primitive object={scene} {...props} />
      <Book />
    </group>
  );
}

// optional prefetch
useGLTF.preload('/stageAssets/stage2/interior/classroom.gltf');
